module.exports = __webpack_public_path__ + "static/media/media_brief_best_place_to_work.35419217.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/media_brief_best_place_to_work.webp
// module id = 317
// module chunks = 0